import { type Config as GQLItem } from '../generated/graphql';
import * as CognitoConfig from '../api/CognitoConfig';

export type VPConfig = {
  cognito?: CognitoConfig.CognitoConfig;
};

export const fromGql = (item: GQLItem): VPConfig => ({
  cognito: item.cognito ? CognitoConfig.fromGql(item.cognito) : undefined,
});
